import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { StoreCardComponent } from './store.component';
import { CardModule } from '../card.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    LazyLoadImageModule,
    CardModule
  ],
  declarations: [
    StoreCardComponent
  ],
  exports: [
    StoreCardComponent
  ]
})
export class StoreCardModule { }
